import React, { useState, useEffect, useMemo } from "react";
import { Row, Col } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import { saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./MenuFile.js";
import { basicFormData } from "./MenuFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import NumberInput from "./../../../custom/components/Number-Input/NumberInput";

const MenuCreate = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,

    dependentDropdownData,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const {
    formData,
    onInputChange,
    formErrors,
    setFormErrors,
    selectedDropOption,
    setSelectedDropOption,
    selectedDropdownOptions,
    handleSelectChange,
  } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType,
    dependentDropdownData
  );

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const validationErrors = validate(validationType, formData.inputData);

      if (!formData.inputData.is_child) {
        delete validationErrors["parent_id"];
      }

      if (!formData.inputData.menu_icon) {
        delete validationErrors["menu_icon"];
      }

      if (Object.keys(validationErrors).length > 0) {
        setLoadingData(false);

        setFormErrors(validationErrors);
        return;
      }
      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const payload = {
        id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData.inputData,
          created_by: isCreating
            ? userDetails.id
            : formData.inputData.created_by,
          updated_by: userDetails.id,
        },
      };

      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.log("err", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };
  const setSelectedOption = (options, value, setSelected) => {
    const matchedOption = options.find((option) => option.value === value);
    setSelected(
      matchedOption
        ? { label: matchedOption.label, value: matchedOption.value }
        : null
    );
  };
  console.log("selectedDropdownOptions", selectedDropdownOptions);

  useEffect(() => {
    if (selectedDropdownOptions.length) {
      setSelectedOption(
        selectedDropdownOptions[0]?.options,
        formData.inputData.parent_id,
        setSelectedDropOption
      );
    }
  }, [formData.inputData.parent_id, selectedDropdownOptions]);
  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-3">
        <Col md="6" className="mt-3">
          <TextInput
            label="Menu Name"
            name="menu_name"
            value={formData.inputData.menu_name}
            onChange={onInputChange}
            placeholder="Menu name"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            parentStyle={{}}
            inputStyle={{}}
            labelStyle={{}}
            maxLength
            minLength
            readOnly={false}
            disabled={false}
            required={false}
            spellcheck={false}
            size
            pattern="[A-Za-z0-9]+"
            autocomplete={"off"}
            customError={formErrors.menu_name}
            asterisk={true}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Menu Icon"
            name="menu_icon"
            value={formData.inputData.menu_icon}
            onChange={onInputChange}
            placeholder="Menu icon"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            parentStyle={{}}
            inputStyle={{}}
            labelStyle={{}}
            maxLength
            minLength
            readOnly={false}
            disabled={false}
            required={false}
            spellcheck={false}
            size
            pattern="[A-Za-z0-9]+"
            autocomplete={"off"}
            asterisk={false}
            customError={formErrors?.menu_icon}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md="6" className="mt-3">
          <TextInput
            label="Menu url"
            name="menu_url"
            value={formData.inputData.menu_url}
            onChange={onInputChange}
            placeholder="Menu url"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            parentStyle={{}}
            inputStyle={{}}
            labelStyle={{}}
            maxLength
            minLength
            readOnly={false}
            disabled={false}
            required={false}
            spellcheck={false}
            size
            pattern="[A-Za-z0-9]+"
            autocomplete={"off"}
            customError={formErrors.menu_url}
            asterisk={true}
          />
        </Col>

        <Col md="6" className="mt-3">
          <NumberInput
            label="Sequence"
            name="sequence"
            value={formData.inputData.sequence}
            onChange={onInputChange}
            placeholder="Sequence"
            inputClassName="form-control"
            labelClassName="form-label"
            autocomplete={"off"}
          />
        </Col>
        {formData.inputData.is_child == 1 && (
          <Col md="6" className="mt-3">
            <SelectInput
              label="Parent"
              value={selectedDropOption}
              options={selectedDropdownOptions}
              onSelect={handleSelectChange}
              placeholder="Select Parent"
              parentClassName=""
              selectClassName=""
              labelClassName="form-label"
              parentStyle={{}}
              selectStyle={{}}
              labelStyle={{}}
              size={1}
              noDataMessage="data not found"
              maxMenuHeight={200}
              isClearable={false}
              customError={formErrors.parent_id}
              asterisk={true}
            />
          </Col>
        )}
      </Row>

      <Row className="mt-3">
        <Col lg="2">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            parentStyle={{}}
            checkboxStyle={{}}
            labelStyle={{}}
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>

        <Col lg="2">
          <CheckboxInput
            label="Is Visible On Mobile"
            name="is_visible_on_mobile"
            value={formData.inputData.is_visible_on_mobile}
            checked={formData.inputData.is_visible_on_mobile}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            parentStyle={{}}
            checkboxStyle={{}}
            labelStyle={{}}
            disabled={false}
            required={false}
            customError={formErrors.is_visible_on_mobile}
          />
        </Col>

        <Col lg="2">
          <CheckboxInput
            label="Is Child"
            name="is_child"
            value={formData.inputData.is_child}
            checked={formData.inputData.is_child}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            parentStyle={{}}
            checkboxStyle={{}}
            labelStyle={{}}
            disabled={false}
            required={false}
            customError={formErrors.is_child}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};
export default MenuCreate;
